<template>
  <div class="experience-share" v-show="display" :class="{ mask: hasCreatePoster }">
    <div class="share-content">
      <swiper :options="swiperOption" ref="posterSwiper">
        <swiper-slide v-for="(item, index) in posterImg" :key="index">
          <img class="poster-img" :src="item" alt="" />
        </swiper-slide>
      </swiper>
      <div class="close-box">
        <p class="text">长按保存海报分享</p>
        <img @click="$emit('close')" class="icon" src="/images/goods/experiencePkg/close-icon.png" alt="" />
      </div>
    </div>
    <div class="poster-container" ref="posterContainer">
      <div class="advertising-img">
        <img :src="shareData.posterInfo[posterImgIndex].picUrl" alt="" @load="completeLoad" />
      </div>
      <div class="share-text-box" :style="styleData.shareTextBoxStyle">
        <div class="tips" :style="styleData.tipsStyle">
          <h3>我是{{ shareName }}</h3>
          <p class="text-days">{{ shareData.posterInfo[posterImgIndex].title }}</p>
          <p class="study">{{ shareData.posterInfo[posterImgIndex].desc||'长按扫码学习好课' }}</p>
        </div>
        <div class="qrcode">
          <qrcode :value="qrcodeUrl" :options="{ size: 77 }"></qrcode>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import html2canvas from 'html2canvas'
import QRcode from '@xkeshi/vue-qrcode'
import { isEmpty } from 'lodash'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'experiencePkgShare',
  components: {
    qrcode: QRcode,
    swiper,
    swiperSlide,
  },
  model: {
    prop: 'display',
    event: 'change',
  },
  props: {
    display: Boolean,
    shareData: {
      type: Object,
      default: function() {
        return {
          qrcodeSrc: '',
          posterInfo: [],
        }
      },
    },
    styleData: {
      type: Object,
      default: function() {
        return {
          shareTextBoxStyle: {
            backgroundColor: '#fb4944',
          },
          tipsStyle: {
            color: '#FAF6D9',
          },
        }
      },
    },
  },
  data() {
    return {
      posterImg: [],
      posterImgIndex: 0,
      hasCreatePoster: false,
      isLoaded: false,
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
      },
    }
  },
  watch: {
    initPoster: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.setLoading({
            show: true,
            text: '海报制作中...',
          })
          this.createPoster()
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      adultInfo: 'auth/adultInfo',
      userInfo: 'auth/userInfo',
      selfInviteCode: 'auth/selfInviteCode',
      headers: 'auth/headers',
    }),
    qrcodeUrl() {
      return this.shareData.qrcodeSrc
      // return `${process.env.VUE_APP_SHARE_URL}/index.html#/goods/experiencePkg?contextId=${this.selfInviteCode}&appId=${this.headers.appId}`
    },
    shareName() {
      // let phoneNumTail = this.userInfo&&this.userInfo.phoneNum&&this.userInfo.phoneNum.substr(-4,4);
      return !isEmpty(this.userInfo) && this.userInfo.name ? this.userInfo.name : `优学用户`
    },
    initPoster() {
      return this.display && !this.hasCreatePoster && this.isLoaded
    },
  },
  methods: {
    ...mapMutations({
      setLoading: 'setLoadingShow',
    }),
    createPoster() {
      this.$nextTick(async () => {
        let height = this.$refs.posterSwiper.$el.offsetHeight
        let width = this.$refs.posterSwiper.$el.offsetWidth
        for (let i = 0; i < this.shareData.posterInfo.length; i++) {
          this.posterImgIndex = i
          await this.$nextTick(() => {
            html2canvas(this.$refs.posterContainer, {
              useCORS: true,
              backgroundColor: null,
              // allowTaint: true,
              // logging: false,
              // letterRendering: true,
              width,
              height,
            }).then((canvas) => {
              this.posterImg.push(canvas.toDataURL('image/png'))
            })
          })
          if (i >= this.shareData.posterInfo.length - 1) {
            this.$nextTick(() => {
              this.hasCreatePoster = true
              this.setLoading({
                show: false,
              })
            })
          }
        }
      })
    },
    completeLoad() {
      this.isLoaded = true
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.experience-share {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* background: rgba(0, 0, 0, 0.6); */
}

.experience-share.mask {
  background: rgba(0, 0, 0, 0.6);
}

.share-content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: inherit;
  width: 301px;
  /* height: 90vh; */
  /* display: flex; */
  /* flex-direction: column; */
}

.share-content .target-img {
  max-width: 80vw;
  max-height: 75vh;
  display: block;
}

.advertising-img {
  width: 100%;
  height: 367px;
}

.advertising-img > img {
  width: 100%;
  height: 100%;
}

.share-text-box {
  height: 136px;
  /* background: #fb4944; */
  padding: 30px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.share-text-box .tips {
  /* color: #FAF6D9; */
  font-size: 12px;
  line-height: 17px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.share-text-box .tips > h3 {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  width: 144px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.share-text-box .tips .text-days {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.tips .text-days > span {
  color: #ff4338;
}

.share-text-box .tips .study {
  line-height: 17px;
}

.share-text-box .qrcode {
  width: 77px;
  height: 77px;
}

.close-box .text {
  line-height: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  padding: 20px 0;
}

.close-box .icon {
  display: block;
  width: 34px;
  margin: 0 auto;
}

/* .share-img {
  flex: 1;
  display: block;
} */

.poster-container {
  width: 301px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-100%);
}

.experience-share .swiper-container {
  height: 503px;
}

.poster-img {
  display: block;
  width: 100%;
  height: 503px;
}
</style>
